/* eslint-disable */
export default {
  feedbackHeader: 'Invia feedback',
  back: 'Indietro',
  revert: 'Annulla',
  instruction:
    "Il tuo feedback è importante per noi. Se incontri problemi nell'uso dell'app, desideri richiedere una nuova funzione o vuoi segnalare un bug, siamo a tua disposizione.",
  fillForm: 'Compila il modulo seguente e fai clic su ',
  useMailBox:
    ' oppure usa direttamente la tua casella di posta e invia la richiesta a ',
  email: 'Il tuo indirizzo e-mail',
  reply: '(così possiamo risponderti)',
  emailPlaceHolder: 'ronald.app@ringcentral.com',
  feedbackTopic: 'Argomento feedback',
  topicPlaceHolder: "Seleziona un'opzione",
  bugReport: 'Segnalazione di bug',
  featureRequest: 'Richiesta di funzione',
  others: 'Altri',
  subject: 'Oggetto',
  subjectPlaceHolder: 'Facci sapere come possiamo aiutarti',
  description: 'Descrizione completa',
  descriptionPlaceHolder: 'Includi tutte le informazioni disponibili',
  send: 'Invia il tuo feedback',
} as const;

// @key: @#@"feedbackHeader"@#@ @source: @#@"Submit Feedback"@#@
// @key: @#@"back"@#@ @source: @#@"Back"@#@
// @key: @#@"revert"@#@ @source: @#@"Revert"@#@
// @key: @#@"instruction"@#@ @source: @#@"Your feedback is valuable for us. If you have problems using the app, want to request a feature, or report a bug, we’re more than happy to help."@#@
// @key: @#@"fillForm"@#@ @source: @#@"Please fill in the form below and click "@#@
// @key: @#@"useMailBox"@#@ @source: @#@" or directly use your mailbox and send your request to "@#@
// @key: @#@"email"@#@ @source: @#@"Your email address"@#@
// @key: @#@"reply"@#@ @source: @#@"(so we can reply to you)"@#@
// @key: @#@"emailPlaceHolder"@#@ @source: @#@"ronald.app@ringcentral.com"@#@
// @key: @#@"feedbackTopic"@#@ @source: @#@"Feedback topic"@#@
// @key: @#@"topicPlaceHolder"@#@ @source: @#@"Please select an option"@#@
// @key: @#@"bugReport"@#@ @source: @#@"Bug report"@#@
// @key: @#@"featureRequest"@#@ @source: @#@"Feature request"@#@
// @key: @#@"others"@#@ @source: @#@"Others"@#@
// @key: @#@"subject"@#@ @source: @#@"Subject"@#@
// @key: @#@"subjectPlaceHolder"@#@ @source: @#@"Let us know how we can help you"@#@
// @key: @#@"description"@#@ @source: @#@"Full description"@#@
// @key: @#@"descriptionPlaceHolder"@#@ @source: @#@"Please include as much information as possible"@#@
// @key: @#@"send"@#@ @source: @#@"Send Your Feedback"@#@
